module.exports = __webpack_public_path__ + "img/ic-check.e015c856.svg";